// 判断是否为外部链接
const isExternalLink = (href: string): boolean => {
  if (!href) return false
  if (href.startsWith('blob:')) return false
  if (href.startsWith('javascript:')) return false // 添加这行处理 javascript: 协议

  const currentHost = window.location.host
  try {
    const url = new URL(href, window.location.origin) // 如果 href 是非法链接，这里会抛出异常
    return url.host !== currentHost && !url.host.includes('localhost')
  } catch {
    // 捕获异常，说明是非法链接，返回 false
    return false
  }
}

// 判断元素是否可见
const isElementVisible = (element: HTMLElement): boolean => {
  const style = window.getComputedStyle(element)
  return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0'
}

export function setupGlobalLinkConfirm() {
  const { createConfirm } = useMessage()

  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement
    const link = target.closest('a')
    if (
      link &&
      isElementVisible(link) &&
      isExternalLink(link.href) &&
      !link.hasAttribute('download')
    ) {
      // 忽略带有特定属性的链接
      if (link.hasAttribute('no-confirm') || link.getAttribute('target') === '_self') {
        return
      }

      event.preventDefault()
      createConfirm({
        title: '外部链接提示',
        iconType: 'warning',
        content: (
          <div>
            您即将离开当前网站，前往外部链接：
            <div v-dompurify-html={link.outerHTML}></div>
            是否继续？
          </div>
        ),
        onOk() {
          window.open(link.href, '_blank')
        }
      })
    }
  })
}
